// extracted by mini-css-extract-plugin
module.exports = {"Item":"Main_Item__1xER3","Oblong":"Main_Oblong__2mvGA","Paintbrush":"Main_Paintbrush__dvLrW","Container":"Main_Container__ZpY0H"};